<template>
  <div>
    <div class="card-body print-form" id="receiptDataVersion">
      <b-row>
        <b-col cols="12">
          <table style="width: 380px; margin: 0px 5px">
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span>
                  <h1
                    class="mb-0 tx-rubik text-center company_name text-uppercase shop-header"
                  >
                    Gnanams Hotel
                  </h1>
                </span>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <h6 class="mt-0 mb-0 tx-rubik tx-12 text-center">
                  299, 301 Clock Tower Rd, Jaffna
                </h6>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <h6 class="mt-0 tx-12 tx-rubik text-center">0212 220 630</h6>
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="font-weight-bold">
          <table style="width: 400px; margin: 0px 5px">
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Order Number
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="font-weight: bold">
                  {{ Order.order_number }}
                </span>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Customer
                </span>
              </td>
              <td
                class="unit-price"
                style="color: black; text-align: right"
                v-if="Order && Order.guest"
              >
                <span class="tx-rubik" style="color: black">
                  {{ Order.guest.name }}
                </span>
              </td>
            </tr>
            <tr v-if="Order && Order.note && String(Order.note).indexOf('Website pickup') === 0">
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Source
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  Website
                </span>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Waiter
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span
                  class="tx-rubik"
                  style="color: black"
                  v-if="Order.waiter && Order.waiter.name"
                >
                  {{ Order.waiter.name }}
                </span>
              </td>
            </tr>
            <tr v-if="Order.room && Order.room.name != null">
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Room
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black">
                  {{ Order.room.name }}
                </span>
              </td>
            </tr>

            <tr v-if="Order.table && Order.table.name != null">
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Table
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black">
                  {{ Order.table.name }}
                </span>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Date
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black">
                  {{ new Date() | formatDateTime }}
                </span>
              </td>
            </tr>

            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Biller
                </span>
              </td>
              <td
                class="unit-price"
                style="color: black; text-align: right"
                v-if="Order.createdby"
              >
                <span class="tx-rubik" style="color: black">
                  {{ Order.createdby.first_name }}
                </span>
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
      <p style="border-top: dashed 1px"></p>

      <b-row>
        <b-col>
          <table style="width: 400px; margin: 0px 5px">
            <thead>
              <tr style="border-bottom: solid 2px">
                <th
                  class="description"
                  style="color: black; text-align: left; width: 200px"
                >
                  Item
                </th>
                <th
                  class="unit-price unit-price-text"
                  style="color: black; text-align: right; width: 100px"
                >
                  Price
                </th>
                <th style="color: black; text-align: right; width: 50px">
                  Qty
                </th>

                <th
                  class="amount unit-price-text"
                  style="color: black; text-align: right; width: 100px"
                >
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(product, index) in Order.items"
                :key="index"
                style="border-top: dashed 1px"
              >
                <td
                  v-if="product.dish"
                  class="description"
                  style="color: black; padding-top: 5px; padding-bottom: 5px"
                >
                  <h6 class="text-left padding-top-0px" style="font-size: 13px">
                    {{ product.dish.name }}-{{ product.unit.name }}
                  </h6>

                  <table class="width-100perc">
                    <tbody>
                      <tr
                        v-for="(item, index) in product.ingredients"
                        :key="index"
                        class="secondry-color text-left"
                      >
                        <td class="text-right">+</td>
                        <td>Add {{ item.name }} ({{ item.amount }})</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  v-if="product.product"
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 110px;
                  "
                >
                  <h6 class="text-left padding-top-0px">
                    {{ product.product.name }}
                  </h6>
                </td>
                <td style="color: black; text-align: right">
                  <span style="color: black">
                    {{ product.amount }}
                  </span>
                </td>
                <td class="quantity" style="color: black; text-align: right">
                  <span
                    style="color: black; text-align: right"
                    v-if="product.adjust_quantity <= 0"
                  >
                    {{ product.quantity }}
                  </span>
                  <span
                    style="color: black; text-align: center"
                    class="tx-rubik"
                    v-if="product.adjust_quantity > 0"
                  >
                    {{ product.adjust_quantity }}g
                  </span>
                </td>

                <td class="amount" style="color: black; text-align: right">
                  <span
                    style="color: black; text-align: right"
                    class="tx-rubik unit-price-text"
                  >
                    {{ product.quantity * product.amount }}.00
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          <table style="width: 400px; margin: 0px 5px">
            <tr>
              <td
                colspan="1"
                class="description"
                style="color: black; text-align: left"
              >
                <hr style="border-top: solid 1px; margin: 1px" />

                <span
                  v-if="Order.items"
                  class="tx-rubik"
                  style="color: black; font-weight: bold"
                >
                  No of items - {{ Order.items.length }}
                </span>
              </td>
              <td
                colspan="1"
                class="description"
                style="color: black; text-align: right; white-space: nowrap"
              >
                <hr style="border-top: solid 1px; margin: 1px" />

                <span
                  v-if="Order.items"
                  class="tx-rubik"
                  style="color: black; text-align: right; font-weight: bold"
                >
                  Payment Type - {{ paymentType.name }}
                </span>
              </td>
            </tr>
            <tr>
              <td
                class="description"
                style="color: black; text-align: left; padding-top: 10px"
              >
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Total
                </span>
              </td>

              <td
                class="unit-price"
                style="color: black; text-align: right; padding-top: 10px"
              >
                <span
                  class="tx-rubik"
                  style="color: black; font-weight: bold"
                  v-if="Order.ingredient_amount > 0"
                >
                  {{ Order.amount + Order.ingredient_amount }}.00
                </span>
                <span
                  class="tx-rubik"
                  style="color: black; font-weight: bold"
                  v-else
                >
                  {{ Order.amount }}.00
                </span>
              </td>
            </tr>

            <!-- {{Order.service_charge}} -->
            <tr v-if="Order.service_charge > 0">
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  {{ Order.order_type === 'take_away' ? 'Packing' : 'Service Charge' }}
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ Order.service_charge }} </span
                >.00
              </td>
            </tr>
            <tr v-if="Order.tax > 0">
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Tax
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ Order.tax }} </span
                >.00
              </td>
            </tr>
            <tr v-if="Order.descount > 0">
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Discount
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ Order.descount }}.00
                </span>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Net Amount
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ Order.net_amount }}.00
                </span>
              </td>
            </tr>
            <tr v-if="EventTablePartial">
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  last Paid ToatalAmount
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ Order.paid_amount }}
                </span>
              </td>
            </tr>

            <tr
              v-if="
                (Order.room && Order.room.name != null) ||
                (Order.table && Order.table.name != null && !EventTable) ||
                paymentAmount > 0
              "
            >
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Received Amount
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ paymentAmount > 0 ? paymentAmount : Order.paid_amount }}
                </span>
              </td>
            </tr>
            <tr
              v-if="
                (Order.room && Order.room.name != null) ||
                (Order.table && Order.table.name != null && !EventTable) ||
                paymentAmount > 0
              "
            >
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Balance Amount
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{
                    (
                      Order.net_amount -
                      (paymentAmount > 0 ? paymentAmount : Order.paid_amount)
                    ).toFixed(2)
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="EventTable">
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Received Amount
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ Order.net_amount }}
                </span>
              </td>
            </tr>
            <tr v-if="TakeawayCondition">
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Received Amount
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ paymentAmount > 0 ? paymentAmount : Order.paid_amount }}
                </span>
              </td>
            </tr>
            <tr v-if="TakeawayCondition">
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Balance Amount
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ paymentAmount - Order.net_amount }}
                </span>
              </td>
            </tr>

            <tr style="margin-top: 10px">
              <td colspan="2" style="margin-top: 20px">
                <h4 style="text-align: center; margin-top: 20px; color: black">
                  <!-- நன்றி மீண்டும் வருக ! -->
                  Thank You Come Again!
                </h4>
              </td>
            </tr>

            <tr style="margin-top: 30px">
              <td
                colspan="2"
                style="
                  font-size: 12px;
                  padding-top: 5px;
                  color: black;
                  text-align: center;
                "
              >
                Powered by SpeedCodeLabs (Pvt) Ltd | 0212 211 599
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import moment from 'moment';
export default {
  name: 'PrintBill',
  props: {
    Order: {
      type: Object,
      default: {},
    },
    paymentType: {
      type: String,
      default: '',
    },
    paymentAmount: {
      type: Number,
      default: 0,
    },
    receivedAmount: {
      type: Number,
      default: 0,
    },
    balanceAmount: {
      type: Number,
      default: 0,
    },
    EventTable: {
      type: Boolean,
      default: false,
    },
    TakeawayCondition: {
      type: Boolean,
      default: false,
    },
    EventTablePartial: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      service_charges: '',
    };
  },
  components: {},
  computed: {
    ...mapState('sitesetting', ['setting']),
  },
  methods: {
    print() {
      this.$htmlToPaper('receiptDataVersion');
    },
  },
  created() {
    this.service_charges = this.setting && this.setting.service_charge;
  },
  // moment(date){
  //   return moment(date).format('LLL');

  // }
};
</script>
<style>
.description,
.description {
  width: 80px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.print-form .description,
.print-form .unit-price,
.print-form .quantity,
.print-form .amount {
  word-break: normal;
}

.unit-price,
.unit-price {
  width: 90px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.unit-price-text {
  text-align: right;
}

.quantity,
.quantity {
  width: 40px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.discount,
.discount {
  width: 90px;
  word-break: break-all;
  padding: 0px 10px;
}

.amount,
.amount {
  width: 100px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.centered {
  text-align: center;
  align-content: center;
}

.ticket {
  width: 155px;
  max-width: 155px;
}

img {
  max-width: inherit;
  width: inherit;
}
#receiptDataVersion {
  width: 100%;
  background: white;
}
</style>
